import styled from 'styled-components';
import {CellValueTextDefaultBox} from './cell-value-text.default.box';
import {Color} from '../../../../../../../../themes/definitions/casino777/casino777-colors';

export const CellValueTextCasino777Box = styled(CellValueTextDefaultBox)`
    color: ${Color.brick};
`;